import React from 'react'

const Home = () => {
  return (
    <div className='center page'><div>Device Managment</div></div>
  )
}

export default Home